<div class="container">
    <div class="row mt-3" style="margin-top: 120px !important;">
			<div class="col-md-12 text-center">
				<img src="xps/assets/img/unauthorized.jpg" class="img-fluid">
			</div>
			<div class="col-md-12 text-center">
				<h3 class="No_authorization">No Authorization Found.</h3>
			</div>
			<div class="col-md-12 text-center mt-3">
				<!-- <button (click)="returnToHome()" class="return-home-auth">Return Home</button> -->
			</div>
	</div>
</div>